import { render, staticRenderFns } from "./POS.vue?vue&type=template&id=238301c4&scoped=true"
import script from "./POS.vue?vue&type=script&lang=js"
export * from "./POS.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/assets/styles/beneficiary.css?vue&type=style&index=1&id=238301c4&prod&scoped=true&lang=css&external"
import style2 from "./POS.vue?vue&type=style&index=2&id=238301c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238301c4",
  null
  
)

export default component.exports